module.exports = __webpack_public_path__ + "img/BLCA_Treg.98f7d51b.png";